import { Component } from '@angular/core';
import { RouterOutlet, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, Routes } from '@angular/router';
import { RequestService } from '../services/request.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../models/user';
import { Translate } from '../services/translate.service';
import { AuthGuardService } from '../services/activate.service';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterOutlet, RouterLink, BsDropdownModule],
  // template: `
  // <pagination [totalItems]="totalItems" [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)"></pagination>
  //
  // <router-outlet></router-outlet>
  // `,
  styleUrls: ['./admin.component.scss'],
  templateUrl: './admin.component.html'
})
export class AdminComponent {
  navs: any[];
  user: User;
  public totalItems: number = 64;
  public currentPage: number = 4;
  public smallnumPages: number = 0;
  lang: string
  shownav: boolean = true;
  navid: boolean = false;
  isHide: boolean = false;
  langText: string = 'jp';
  titleName: string = '';
  showUpdatePasswordTime = false;
  async ngOnInit() {
    await this.setTranslateConfig(); // 翻訳設定を初期化（完了を待つ） - init()内で既に'jp'に設定済み
    this.titleName = 'Festaria';
    this.getUserMessage();
  }
  public setPage(pageNo: number): void {
    this.currentPage = pageNo;
  }

  public pageChanged(event: any): void {
    console.log('Page changed to: ' + event.page);
    console.log('Number items per page: ' + event.itemsPerPage);
  }
  constructor(
    public request: RequestService, 
    public translate: Translate, 
    public router: Router,
    private authGuard: AuthGuardService
  ) {
    this.navs = [
      {
        "name": "会員管理",
        "nameEn": "User",
        "nameJp": "会員管理",
        "icon": "fa-user-circle",
        "path": "/admin/auth/member"
      },
      {
        "name": "社員管理",
        "nameEn": "User",
        "nameJp": "社員管理",
        "icon": "fa-user",
        "path": "/admin/auth/user"
      },
      {
        "name": "店舗管理",
        "nameEn": "Store",
        "nameJp": "店舗管理",
        "icon": "fa-building",
        "path": "/admin/shop/store"
      },
      {
        "name": "注文管理",
        "nameEn": "Order",
        "nameJp": "注文管理",
        "icon": "fa-star",
        "path": "/admin/shop/order"
      },
      {
        "name": "DM管理",
        "nameEn": "DM管理",
        "nameJp": "DM管理",
        "icon": "fa-file",
        "path": "/admin/fdcp/dm"
      },

    ]
    // navigations.forEach(nav =>{
    //   var name = nav
    //   if(nav == 'takashimaya'){
    //     name = nav + '/web'
    //   }
    //   let path = '/assets/' + name + '/admin/nav.json';
    //   this.request.get(path).then(res =>{
    //     res.forEach((e:any)=>{
    //       this.navs.push(e);
    //     })
    //   })
    // })
    // console.log(this.navs)
    this.lang = this.translate.lang
    this.langText = (this.translate.lang == 'zh') ? '中文' : (this.translate.lang == 'en') ? 'ENGLISH' : '日本語';
  }

  async setTranslateConfig(): Promise<void> {
    // 翻訳初期化を有効化（完了を待つ） - init()内で既に言語設定と翻訳ファイル読み込みが完了
    await this.translate.init();

    this.langText = (this.translate.lang == 'zh') ? '中文' : (this.translate.lang == 'en') ? 'ENGLISH' : '日本語';
    console.log('🌐 翻訳テスト:', this.translate.instant('alert.retry'));
    console.log('✅ 翻訳設定完了 - 言語:', this.translate.lang);
  }

  async setLocale(lang: string) {
    this.lang = lang;
    this.translate.lang = lang;
    await this.translate.use(lang);
    this.langText = (this.translate.lang == 'zh') ? '中文' : (this.translate.lang == 'en') ? 'ENGLISH' : '日本語';
    // console.log('a',this.translate.instant('alert.retry'))
    this.translate.eventbus.emit({
      lang: lang
    });
    console.log(this.translate.lang);
  }

  logout() {
    // Call backend logout API first (optional)
    this.request.post('api/auth/logout', {admin: true}).then(res => {
      console.log('Backend logout response:', res);
    }).catch(error => {
      console.log('Backend logout error (continuing with local logout):', error);
    }).finally(() => {
      // Always perform local logout regardless of backend response
      this.authGuard.logout();
    });
  }

  getUserMessage() {
    console.log('📞 AdminComponent.getUserMessage() called');

    // Check if user is authenticated before making API call
    const isAuth = this.authGuard.isAuthenticated();

    console.log('🔍 AdminComponent: isAuthenticated =', isAuth);

    if (!isAuth) {
      console.log('❌ AdminComponent: User not authenticated, redirecting to login');
      this.router.navigate(['/login']);
      return;
    }

    console.log('✅ AdminComponent: User authenticated, fetching user data from API');

    this.request.get('api/auth').then(res => {
      if (res && res.status) {
        this.user = new User(res.result.user_id, res.result.avatar, res.result.nickname,
          res.result.sex, res.result.email, res.result.phone, res.result.address, res.result.active);
        this.user.staffCode = res.result.staff_code;
        localStorage.setItem('dashboardActive', this.user.active.toString());
        
        if (res.result.roles && res.result.roles.length > 0) {
          res.result.roles.forEach((e: any) => {
            localStorage.setItem('userRole', e);
            
            if ((e.indexOf('store_staff') !== -1) || (e === 'store_staff_new')) {
              this.navs = [
                {
                  name: '会員管理',
                  nameEn: 'User',
                  nameJp: '会員管理',
                  icon: 'fa-user-circle',
                  path: '/admin/auth/member'
                },
                {
                  name: '注文管理',
                  nameEn: 'Order',
                  nameJp: '注文管理',
                  icon: 'fa-star',
                  path: '/admin/shop/order'
                },
                {
                  "name": "DM管理",
                  "nameEn": "DM管理",
                  "nameJp": "DM管理",
                  "icon": "fa-file",
                  "path": "/admin/fdcp/dm"
                },
              ];
            } else if(e == 'general') {
              this.navs = [
                {
                  "name": "会員管理",
                  "nameEn": "User",
                  "nameJp": "会員管理",
                  "icon": "fa-user-circle",
                  "path": "/admin/auth/member"
                },
                {
                  "name": "注文管理",
                  "nameEn": "Order",
                  "nameJp": "注文管理",
                  "icon": "fa-star",
                  "path": "/admin/shop/order"
                },
                {
                  "name": "DM管理",
                  "nameEn": "DM管理",
                  "nameJp": "DM管理",
                  "icon": "fa-file",
                  "path": "/admin/fdcp/dm"
                },
              ]
            }
          });
        }
        
        // Check dashboard activation status
        // active=0の場合はパスワード変更画面に遷移
        if (!this.user.active) {
          this.router.navigate(['/admin/password']);
        }
      } else {
        console.log('Failed to get user info, redirecting to login');
        this.authGuard.logout();
      }
    }).catch(error => {
      console.log('Error getting user info, redirecting to login:', error);
      this.authGuard.logout();
    });
  }

  changeMenu() {
    this.isHide = !this.isHide;
  }

  childrenShow(nav: any) {
    nav.isHidden = !nav.isHidden
    nav.isActive = !nav.isActive
  }

}
